import { combineReducers } from 'redux';
import users from './users/userReducer';
import user from './user/userReducer';
import menu from './menu/menuReducer';
import order from './order/orderReducer';
import cards from './cards/cardsReducer';

export default combineReducers({ user, users, menu, order, cards});
